import React, { useState } from 'react';
import cn from 'classnames';
import Footer from 'components/Footer/Footer';
import { Link } from "react-router-dom";
import styles from './signin.module.scss';
import dash_styles from '../mychargers.module.scss';
import pass_dash_styles from './registrationSuccess.module.scss';

import { Auth } from 'aws-amplify';

async function logIn() {
    try {
        const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
        // const user = await Auth.signIn(username, password);
    } catch (error) {
        console.log('error signing in', error);
    }
}





export default function PasswordSuccess(props) {
    const [userData, setUserData] = useState({ userName: '', password: '' });
    const [errorMessage, setErrorMessage] = useState({ value: '' });

    async function logIns(userName, password) {
        try {
            // const user = await Auth.signIn("fleetboxstaging@nuvve.com", "@!V^f$hR08!wca@!");
            if (userName === "" || password === "") {
                setErrorMessage((prevState) => ({
                    value: "Empty username/password field",
                }));
            } else {
                console.log(userData.username);
                const user = await Auth.signIn(userName, password);
                console.log(JSON.stringify(user));
                //Signin Success
                // localStorage.setItem('isLogin', true);
                // window.location.pathname = "/myChargers";
            }

        } catch (error) {
            console.log('error signing in', error);
            //If credentials entered is invalid
            setErrorMessage((prevState) => ({ value: "Invalid username/password" }));
        }
    }


    const handleInputChange = (e) => {
        setUserData((prevState) => {
            return {
                ...prevState,
                [e.target.name]: e.target.value,
            };
        });
    };

    // const handleSubmit = (e) => {
    //   e.preventDefault();
    //   console.log("called");
    //   logIns(userData.userName, userData.password);
    //   //if username or password field is empty, return error message

    // };

    const handleSubmit = (e) => {
        e.preventDefault();
        logIn();
        //if username or password field is empty, return error message
        if (userData.userName === "" || userData.password === "") {
            setErrorMessage((prevState) => ({
                value: "Empty username/password field",
            }));
        } else if (
            userData.userName.toLowerCase() === "admin" &&
            userData.password === "test@1234"
        ) {
            //Signin Success
            localStorage.setItem('isLogin', true);
            window.location.pathname = "/myChargers";
        } else {
            //If credentials entered is invalid
            setErrorMessage((prevState) => ({ value: "Invalid username/password" }));
            return;
        }
    };

    return (
        <div className={`ldpg ${cn(dash_styles.main, dash_styles.main_layout)}`}>
            <div className={cn(dash_styles.main_flex, pass_dash_styles.main_flex)}>

                <img src={require('assets/logo.png').default} alt="Rectangle 1" className={cn(styles.logo_boxl1, styles.logo_boxl_layout1)} />

                <div className={cn(pass_dash_styles.set_height)}>
                <div className={cn(pass_dash_styles.contains_border)}>
                <img src={require('assets/Vector (2).svg').default} alt="registered successfully" className={cn(styles.key_img)} />
                <h1 className={cn(styles.sent_text, styles.sent_text_layout)}>
                {'Successful'}
                </h1>
                <span className={cn(styles.sent_text2, styles.sent_text_layout2)}>
                {'Password has been changed successfully.'}
                </span>
                <span className={cn(styles.sent_text2, styles.sent_text_layout2)}>
                <Link to="/signin" className={cn(pass_dash_styles.link_style)}>
                {' Please click'}
                </Link>
                </span>
                <span className={cn(styles.sent_text2, styles.sent_text_layout2)}>
                {' here to login.'}
                </span>
                    {/* <form onSubmit={handleSubmit}>
                        <div className={cn(styles.panel_group, styles.panel_group_layout)}>
                            {errorMessage.value !== '' && (<p className={cn(styles.error)}> {errorMessage.value} </p>)}

                            <div className={cn(styles.security_username, styles.security_username_layout)}>
                                <h1 className={cn(styles.username_title, styles.username_title_layout)}>
                                    {'Security Question'}
                                </h1>
                                <input type="text" name="question" onChange={(e) => handleInputChange(e)} className={cn(styles.security_username_box, styles.security_username_box_layout)} />
                            </div>

                            <div className={cn(styles.security_username, styles.security_username_layout)}>
                                <h1 className={cn(styles.password_title, styles.password_title_layout)}>
                                    {'Security Answer'}
                                </h1>
                                <input type="text" name="answer" onChange={(e) => handleInputChange(e)} className={cn(styles.security_username_box, styles.security_username_box_layout)} />
                            </div>
                                <button type='submit' disabled={!userData.userName || !userData.password} className={cn(styles.panel_group_big_title, styles.panel_group_big_title_layout, styles.panel_group_block, styles.panel_group_block_layout)}>
                                    {'Submit'}
                                </button>
                            
                        </div>
                    </form> */}
                </div>
                </div>
                <Footer></Footer>
                {/* <footer className={cn(styles.footer_block, styles.footer_block_layout)}> */}

                {/* <div
          style={{
            '--src': `url(${
              require('assets/logo.png').default
            })`
          }}
          className={cn(styles.footer_line, styles.footer_line_layout)}
        />

        <div className={cn(styles.footer_flex, styles.footer_flex_layout)}>
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body,
                styles.footer_text_body_layout
              )}>
              {'Privacy'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body1,
                styles.footer_text_body1_layout
              )}>
              {'Terms of use'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer1)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body2,
                styles.footer_text_body2_layout
              )}>
              {'Support@nuvve.com'}
            </div>
          </div>
          <div className={cn(styles.footer_flex_spacer2)} />
          <div className={cn(styles.footer_flex_item)}>
            <div
              className={cn(
                styles.footer_text_body3,
                styles.footer_text_body3_layout
              )}>
              {'© 2021 NUVVE Corporation'}
            </div>
          </div>
        </div> */}
                {/* </footer> */}
            </div>
        </div>

    );
}

PasswordSuccess.inStorybook = true;